import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';
import {
  loadFailureCid,
  loadFailureEst,
  loadRequestCid,
  loadRequestEst,
  loadSuccessCid,
  loadSuccessEst,
} from './actions';

export function* loadEstados({ payload }: ReturnType<typeof loadRequestEst>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getEstados&token=${state.auth.token}`
    );
    yield put(loadSuccessEst(response.data.estados));
  } catch (error: any) {
    yield put(loadFailureEst());
    if (error.response) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      console.error('error.message', error.message);
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    }
  }
}

export function* loadCidades({ payload }: ReturnType<typeof loadRequestCid>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}getCidades&token=${state.auth.token}`,
      {
        codUf: payload.codUf,
      }
    );

    yield put(loadSuccessCid(response.data.cidades));
  } catch (error: any) {
    yield put(loadFailureCid());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar a lista de estdos e cidades, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
